export default __webpack_public_path__ + "static/media/Photo 5 - BR - Brasseurs d'air.c2484c53.png";